import { GetReceiveCouponResp } from "optimus-front/lib/utils/zeusFetch";
import { LinkTargetType } from "optimus-front/lib/services/playground";
import { IOSNOLOGINSTATUS } from "optimus-front/lib/components/LTReceiveToast";
import { SuccessCode } from "optimus-front/lib/mobile/views/CouponCode";

import { isUndefinedOrEmpty } from "utils/string";
import { tryDecodeURIComponent } from "utils/browser/uri";

import { isPC } from "./website";
import { isUAT } from "./debug";
import { getSearchString, getOrigin } from "../ssrcontext";

export const getPathSearchParams = function (url: string = "") {
	let obj: { [key: string]: any } = {};
	let str: string = "";
	let strArr: string[] = [];
	const splitSearchParamReg: RegExp = /([^=]+)=(.+)/;
	url = url.replace(/^\?+/gi, "?");
	if (url.length < 2 || url[0] !== "?") {
		return obj;
	}

	str = url.substring(1);
	/**
	 * safari 不支持正则的向后搜索
	 */
	strArr = str.split("&");
	for (let value of strArr) {
		if (value.includes("=")) {
			const result: RegExpMatchArray | null = value.match(splitSearchParamReg);
			if (result !== null) {
				const prp: string = result[1];
				let val: string = result[2];
				obj[prp] = tryDecodeURIComponent(val);
			}
		}
	}
	return obj;
};

export function getSearchParamValue(searchKey: string, url: string = "") {
	url = url || getSearchString() || "";
	const searchParams = getPathSearchParams(url);
	const keyReg = new RegExp(`^${searchKey}$`, "i");
	let value: any = "";

	for (let prp in searchParams) {
		if (keyReg.test(prp)) {
			value = searchParams[prp];
		}
	}
	return value;
}

export function getLocalProductUrl(gpid: string): string {
	return gpid ? `${getOrigin()}/product/${gpid}.html` : "";
}

export const getSite = () => {
	let site = "1";
	if (!isPC()) {
		site = `${site}-2`;
	}
	return site;
};

export function genPrmLink(
	prm: { floor: string | number; position: string | number },
	url: string = "",
): string {
	if (url === undefined || url === "") {
		return "";
	}
	if (url.startsWith("#") || url.match(/prm=(?=\d+\.)/)) {
		return url;
	}
	let postUrl = url;
	let { floor, position } = prm;

	floor = floor.toString();
	position = position.toString();

	// 1 固定  65表示 tights
	// PRD: https://www.tapd.cn/22265281/prong/stories/view/1122265281001032651

	const prmString = [getSite(), "65", floor, position]
		.filter((v) => !isUndefinedOrEmpty(v))
		.join(".");
	let startChat = "?";
	if (postUrl.includes("?")) {
		startChat = postUrl.endsWith("&") ? "" : "&";
	}
	return `${postUrl}${startChat}prm=${prmString}`;
}

/**
 * 作用: 替换url中的参数值
 * 返回值：修改好参数的url，默认需改当前页面的url中的参数，返回新的url
 */
export const replaceUrlParamVal = (
	paramName: string,
	replaceWith: string,
	url: string = window.location.href,
) => {
	let re = new RegExp(`(${paramName}=)([^&]*)`, "ig");
	const result = url.replace(re, `${paramName}=${replaceWith}`);
	re = null;
	return result;
};

export const jumpToLogin = (
	isMobile: boolean = false,
	isInApp: boolean = false,
	aTarget: LinkTargetType = LinkTargetType.Blank,
): Promise<GetReceiveCouponResp> => {
	if (aTarget === LinkTargetType.Self) {
		return Promise.resolve({
			code: SuccessCode,
			error_msg: [],
			extInfo: [],
			result: "",
			info: {
				status: IOSNOLOGINSTATUS, // 自定义状态码 IOS 未登录
			},
		});
	}
	if (isInApp) {
		let element = document.createElement("a");
		element.setAttribute("href", "litb://login");
		element.style.display = "none";
		document.body.appendChild(element);
		element.click();
		document.body.removeChild(element);
	}
	if (isUAT()) {
		if (isMobile) {
			location.replace("https://gmqa1-a.lightinthebox.tbox.me/en/signin");
		} else {
			location.replace(`https://w1.tbox.me/index.php?main_page=login`);
		}
	} else {
		location.replace(
			`https://gw.lightinthebox.com/index.php?main_page=login&targetUrl=${location?.href}`,
		);
	}
	return Promise.resolve({
		code: "",
		info: {
			status: 0,
		},
	} as GetReceiveCouponResp);
};
